import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { InviteMemberButton } from "@components/common/invite-member-button";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { ProjectRoleAutoComplete } from "@components/role/role-autocomplete/project-role-autocomplete";
import { Dialog } from "@flat-ui";
import { useInviteMembersToProject } from "@hooks/projects/use-invite-members-to-project";
import { Stack } from "@mui-wrapper";
import { INVITE_DIALOG_CLOSE_DELAY_MS } from "@src/constants/invite-constants";
import { delay } from "@utils/time-utils";
import { useState } from "react";
/** Renders the invite member button and the functionality in project overview */
export function InviteMemberToProject(t0) {
  const $ = _c(31);
  const {
    project,
    buttonVariant: t1
  } = t0;
  const buttonVariant = t1 === undefined ? "outlined" : t1;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = async () => {
      setIsDialogOpen(false);
      await delay(INVITE_DIALOG_CLOSE_DELAY_MS);
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== project) {
    t3 = {
      project,
      location: "invite-member-to-project",
      initialRole: "RESOURCE_VIEWER",
      onInviteSuccess: t2
    };
    $[1] = project;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const {
    autocompleteOptions,
    selectedMembers,
    helperText,
    handleMemberSelect,
    onInputChange,
    isValidInput,
    selectedRole,
    setSelectedRole,
    canAssignProjectRoles,
    isLoading,
    shouldSendInviteDisable,
    handleConfirm,
    reset
  } = useInviteMembersToProject(t3);
  let t4;
  if ($[3] !== reset) {
    t4 = function onOpenInviteDialog() {
      reset();
      setIsDialogOpen(true);
    };
    $[3] = reset;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const onOpenInviteDialog = t4;
  let t5;
  if ($[5] !== buttonVariant || $[6] !== onOpenInviteDialog) {
    t5 = <InviteMemberButton buttonVariant={buttonVariant} onClick={onOpenInviteDialog} />;
    $[5] = buttonVariant;
    $[6] = onOpenInviteDialog;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = canAssignProjectRoles ? "Invite members to project" : "Invite viewers to project";
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsDialogOpen(false);
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== canAssignProjectRoles || $[10] !== selectedRole || $[11] !== setSelectedRole) {
    t8 = canAssignProjectRoles && <Stack sx={{
      marginBottom: SPACE_ELEMENTS_OF_MODAL
    }}><ProjectRoleAutoComplete isRequired={true} selectedRole={selectedRole} onChange={role => setSelectedRole(role)} /></Stack>;
    $[9] = canAssignProjectRoles;
    $[10] = selectedRole;
    $[11] = setSelectedRole;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== autocompleteOptions || $[14] !== handleMemberSelect || $[15] !== helperText || $[16] !== isValidInput || $[17] !== onInputChange || $[18] !== selectedMembers) {
    t9 = <MembersAutocomplete isRequired={true} hasAutoFocus={true} label="Members" helperText={helperText} onInputChange={onInputChange} options={autocompleteOptions} selectedOptions={selectedMembers} handleMemberSelect={handleMemberSelect} isValid={isValidInput} />;
    $[13] = autocompleteOptions;
    $[14] = handleMemberSelect;
    $[15] = helperText;
    $[16] = isValidInput;
    $[17] = onInputChange;
    $[18] = selectedMembers;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== handleConfirm || $[21] !== isDialogOpen || $[22] !== isLoading || $[23] !== shouldSendInviteDisable || $[24] !== t6 || $[25] !== t8 || $[26] !== t9) {
    t10 = <Dialog title={t6} confirmText="Send Invite" open={isDialogOpen} onConfirm={handleConfirm} showSpinner={isLoading} isConfirmDisabled={shouldSendInviteDisable} onCancel={t7} dataTestId="invite-members-to-project-dialog">{t8}{t9}</Dialog>;
    $[20] = handleConfirm;
    $[21] = isDialogOpen;
    $[22] = isLoading;
    $[23] = shouldSendInviteDisable;
    $[24] = t6;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t5) {
    t11 = <>{t5}{t10}</>;
    $[28] = t10;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
}